module.exports = __webpack_public_path__ + "img/madera025.fe7bd7ee.jpg";